const { default: CommonServices } = require("./common/common");

class UserManagementService extends CommonServices {
  constructor() {
    super("/users");
  }
}

const userManagementService = new UserManagementService();
export default userManagementService;
